import {useQuery} from "@tanstack/react-query";
import {listMyFavoriteGamesService} from "../../services/games/miniGames/favoriteGames.service";
import {useAuthStore} from "../../store/useAuth.store";

const useListFavoriteGames = () => {
  const authStatus = useAuthStore(state => state.authStatus);

  const {data, isSuccess, isLoading, isError, error} = useQuery({
    queryKey: ["listFavoriteGames"],
    queryFn: listMyFavoriteGamesService,
    staleTime: 300,
    enabled: authStatus === "authenticated",
  });

  return {listFavGames: data, isSuccess, isError, error, isLoading};
};

export default useListFavoriteGames;
